import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { logOutMsg, t } from '../../common/i18n/index.js';
import { Modal } from '../Modal/Modal.js';
import { ModalButtons } from '../Modal/ModalButtons.js';

export interface ElisaIdMigrationConflictModalProps {
  onLogout: () => void;
}

const accountConflictMessage =
  'This Elisa ID has already been migrated and associated with another account in the company. Please use your Elisa ID to login again.';

export const ElisaIdMigrationConflictModal = ({ onLogout }: ElisaIdMigrationConflictModalProps) => {
  return (
    <Modal size="m" className="of-elisa-id-migration-verify-contact__dialog">
      <div
        className={`of-elisa-id-migration-verify-contact of-elisa-id-migration-verify-contact__conflict ${dsClass.DISPLAY_FLEX}`}
      >
        <div className="login-icon" />
        <h3 className={`${dsClass.MARGIN_0}`}>{t.IW51('Elisa ID conflict')}</h3>
        <p>{t.JRBO(accountConflictMessage)}</p>
      </div>
      <ModalButtons>
        <CL.Button color="primary" size="l" onClick={onLogout}>
          {t.LQ3X(logOutMsg)}
        </CL.Button>
      </ModalButtons>
    </Modal>
  );
};
